<template>
  <div>
    <!-- <player :source.sync="liveStreamDetail.streamDetail.watchURL" /> -->
    <!-- <div id='live-video'></div> -->
    <!-- <div class="text-right">

        <v-btn
          class="ml-auto px-5 subtitle-1"
          color="error"
          dark
          rounded
         
        >
          <v-icon left>mdi-phone-hangup</v-icon>End Broadcast
        </v-btn>
    </div>-->

    <div class="pa-2 pl-3 pt-0 ma-1 page-card">
      <v-row>
        <v-col :cols="12" :lg="7" :md="7" :sm="12" class="pr-7 pl-7 pt-3">
          <!-- <div id='video'></div> -->
          <player :source.sync="liveStreamDetail.streamDetail.watchURL" />
          <!-- <div class="live-preview px-1" >
          <v-btn class="ma-1 mt-2 white--text font-weight-black" color="red">Live 12:46</v-btn>
          <v-btn class="ma-1 mt-2 white--text font-weight-black" color="grey">
            <v-icon class="mr-1">visibility</v-icon>12K
          </v-btn>
          </div>-->
          <div id="video"></div>
          <div class="mt-6 live-detail">
            <v-tabs
              v-model="tab"
              background-color="white"
              color="white"
              class="option"
              centered
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#tab-1" class="subtitle-2 tab-live-detail">
                <v-icon class="pr-2" small>speed</v-icon>Dashboard
              </v-tab>
              <v-tab href="#tab-2" class="subtitle-2 tab-live-detail">
                <v-icon class="pr-2" small>picture_as_pdf</v-icon>PDF Files
              </v-tab>
              <v-tab href="#tab-3" class="subtitle-2 tab-live-detail">
                <v-icon class="pr-2" small>image</v-icon>Pictures
              </v-tab>
              <v-tab href="#tab-4" class="subtitle-2 tab-live-detail">
                <v-icon class="pr-2" small>link</v-icon>URL Links
              </v-tab>
              <v-tab href="#tab-5" class="subtitle-2 tab-live-detail">
                <v-icon class="pr-2" small>info</v-icon>Event Info
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="live-detail-content">
              <!-- <v-tab-item v-for="i in 2" :key="i" :value="'tab-' + i">
                <div flat >
                  <div class="blue-grey--text subtitle-1 font-weight-light">{{ text }}</div>
                </div>
              </v-tab-item>-->
              <v-tab-item key="1" value="tab-1">
                <div flat class="pa-8">
                  <dashboard :liveId.sync="liveId" />
                </div>
              </v-tab-item>
              <v-tab-item key="2" value="tab-2">
                <div flat>
                  <pdf :pdfs.sync="liveStreamDetail.pdfs" />
                </div>
              </v-tab-item>
              <v-tab-item key="3" value="tab-3">
                <div flat class="pa-4 pt-0">
                  <imageLive :images.sync="liveStreamDetail.images" />
                </div>
              </v-tab-item>
              <v-tab-item key="4" value="tab-4">
                <div flat class="pa-4">
                  <URLLink :urls.sync="liveStreamDetail.urls" />
                </div>
              </v-tab-item>
              <v-tab-item key="5" value="tab-5">
                <div flat class="pa-8">
                  <info
                    :title.sync="liveStreamDetail.title"
                    :displayName.sync="liveStreamDetail.created_by.displayName"
                    :displayImage.sync="liveStreamDetail.created_by.image"
                    :startTime.sync="liveStreamDetail.startTime"
                    :endTime.sync="liveStreamDetail.endTime"
                    :urlServer.sync="liveStreamDetail.streamDetail.streamURL"
                    :streamKey.sync="liveStreamDetail.streamDetail.streamKey"
                    :courseId.sync="liveStreamDetail.courses[0]"
                  />
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col>
        <v-col :cols="12" :lg="4" :md="4" :sm="12" class="pa-0 pt-3">
          <v-slide-y-transition>
            <div class="mb-3" v-if="isLiveChatShow">
              <div class="header-option">
                <v-col class="menu-title">
                  <v-col class="pa-0 title font-weight-medium">Live Chat</v-col>
                  <v-col class="pa-0 subtitle-2 font-weight-thin"
                    >อ่านความคิดเห็นและส่งข้อความถึงผู้ชม</v-col
                  >
                </v-col>
              </div>
              <div class="option-content">
                <chat
                  :courseId.sync="liveStreamDetail.courses[0]"
                  :liveId.sync="liveStreamDetail.streamDetail.chatRoom"
                />
              </div>
            </div>
          </v-slide-y-transition>

          <v-slide-y-transition>
            <div class="mb-3" v-if="isLiveQShow">
              <div class="header-option">
                <v-col class="menu-title">
                  <v-col class="pa-0 title font-weight-medium">Live Q</v-col>
                  <v-col class="pa-0 subtitle-2 font-weight-thin"
                    >การส่งคำถามที่เตรียมไว้ล่วงหน้าและส่งให้ผู้ชมตอบคำถามแบบเรียลไทม</v-col
                  >
                </v-col>
              </div>
              <div class="option-content">
                <div class="message-container">
                  <div class="message-scroll">
                    <div class="message-detail pa-4 pb-0">
                      <div
                        class="content pa-4 mb-4"
                        v-for="(qList, index) in arrQuestion"
                        :key="qList._id"
                      >
                        <v-row align="center" no-gutters>
                          <v-col class="divQ pa-0">
                            <v-col class="pa-0 subtitle-2 font-weight-bold"
                              >คำถามข้อที่ {{ index + 1 }}</v-col
                            >
                            <!-- <v-col class="pa-0 body-2 font-weight-light">{{qList.question }}</v-col> -->
                            <span
                              class="body-2 font-weight-light grey--text text--darken-1"
                            >
                              &nbsp;
                              <v-icon v-if="qList.question == ''"
                                >mdi-image</v-icon
                              >
                              &nbsp;
                              {{
                                qList.question == '' ? 'รูปภาพ' : qList.question
                              }}
                            </span>
                          </v-col>

                          <v-col
                            cols="auto"
                            v-if="arrQuestion[index].historySend.length == 0"
                          >
                            <v-row no-gutters>
                              <v-col cols="auto" class="mr-2">
                                <a @click="editQuestion(qList.id)">
                                  <div
                                    class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                                  >
                                    Edit
                                  </div>
                                </a>
                              </v-col>
                              <v-col cols="auto">
                                <a
                                  @click="
                                    showTimeQuestion(qList.id, qList.time)
                                  "
                                >
                                  <div
                                    class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                                  >
                                    Send
                                  </div>
                                </a>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="12"
                            v-if="arrQuestion[index].historySend.length > 0"
                            class="mt-3"
                          >
                            <a @click="viewReport(qList.id, index)">
                              <div
                                class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                              >
                                <v-icon class="mr-1 white--text pr-3"
                                  >assignment</v-icon
                                >View Report
                              </div>
                            </a>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <div class="px-7">
                      <v-col
                        cols="12"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        class="pa-0 pt-5 pb-4"
                      >
                        <v-btn
                          color="#308AB7"
                          large
                          dark
                          @click="viewLeaderBoard()"
                          class="full-width title btnLeader"
                        >
                          <v-img
                            src="@/assets/icon/leader_board.png"
                            lazy-src="@/assets/icon/leader_board.png"
                            max-width="20"
                            class="mr-3"
                          ></v-img
                          >&nbsp; LEADER BOARD
                        </v-btn>
                      </v-col>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-slide-y-transition>

          <v-slide-y-transition>
            <div class="mb-3" v-if="isNameCheckShow">
              <div class="header-option">
                <v-col class="menu-title">
                  <v-col class="pa-0 title font-weight-medium"
                    >Name Check</v-col
                  >
                  <v-col class="pa-0 subtitle-2 font-weight-thin"
                    >คุณสามารถเช็คชื่อแบบเรียลไทม์
                    โดยจะส่งข้อความให้ผู้เรียนทำการตอบรับ</v-col
                  >
                </v-col>
              </div>
              <checkName :liveId.sync="liveStreamDetail._id" />
              <!-- <div class="option-content px-3 py-3">
              <v-col>
                <div class="content px-1 py-1">
                  <v-row class="px-3" align="center">
                    <v-col>
                      <v-col class="pa-0 title font-weight-black primary--text"># NameCheck 1</v-col>
                      <v-col class="pa-0 body-2 font-weight-light">เมื่อเวลา 13:00 น.</v-col>
                    </v-col>
                    <v-col cols="4">
                      <div class="px-1 py-1 text-right">
                        <v-col
                          class="pa-0 subtitle-1 font-weight-light d-flex align-center justify-center"
                        >การตอบรับ</v-col>
                        <v-col class="headline font-weight-black py-0">50</v-col>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col>
                <div class="content px-1 py-1">
                  <v-row class="px-3" align="center">
                    <v-col>
                      <v-col class="pa-0 title font-weight-black primary--text"># NameCheck 2</v-col>
                      <v-col class="pa-0 body-2 font-weight-light">เมื่อเวลา 13:00 น.</v-col>
                    </v-col>
                    <v-col cols="4">
                      <div class="px-1 py-1 text-right">
                        <v-col
                          class="pa-0 subtitle-1 font-weight-light d-flex align-center justify-center"
                        >การตอบรับ</v-col>
                        <v-col class="headline font-weight-black py-0">50</v-col>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col>
                <div class="content px-1 py-1">
                  <v-row class="px-3" align="center">
                    <v-col>
                      <v-col class="pa-0 title font-weight-black primary--text"># NameCheck 3</v-col>
                      <v-col class="pa-0 body-2 font-weight-light">เมื่อเวลา 13:00 น.</v-col>
                    </v-col>
                    <v-col cols="4">
                      <div class="px-1 py-1 text-right">
                        <v-col
                          class="pa-0 subtitle-1 font-weight-light d-flex align-center justify-center"
                        >การตอบรับ</v-col>
                        <v-col class="headline font-weight-black py-0">50</v-col>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col class="mt-5">
                <div class="button px-1 py-2">
                  <v-col
                    class="pa-0 subtitle-1 font-weight-light d-flex align-center justify-center"
                  >
                    <v-icon class="mr-1 white--text pr-3">add</v-icon>New Check
                  </v-col>
                </div>
              </v-col>

              <v-col>
                <div class="button px-1 py-2">
                  <v-col
                    class="pa-0 subtitle-1 font-weight-light d-flex align-center justify-center"
                  >
                    <v-icon class="mr-1 white--text pr-3">refresh</v-icon>Refresh
                  </v-col>
                </div>
              </v-col>
              </div>-->
            </div>
          </v-slide-y-transition>

          <v-slide-y-transition>
            <div class="mb-3" v-if="isParticipantShow">
              <div class="header-option">
                <v-col class="menu-title">
                  <v-col class="pa-0 title font-weight-medium"
                    >Participant</v-col
                  >
                  <v-col class="pa-0 subtitle-2 font-weight-thin"
                    >รายชื่อผู้เรียนทั้งหมดที่เข้าเรียนในคลาสนี้</v-col
                  >
                </v-col>
              </div>
              <div class="option-content pb-0">
                <participant
                  :courseId.sync="liveStreamDetail.courses[0]"
                  :liveId.sync="liveStreamDetail._id"
                />
              </div>
            </div>
          </v-slide-y-transition>

          <v-slide-y-transition>
            <div class="mb-3" v-if="isLivePollShow">
              <div class="header-option">
                <v-col class="menu-title pa-3">
                  <v-col class="pa-0 title font-weight-medium">Poll</v-col>
                  <v-col class="pa-0 subtitle-2 font-weight-thin">
                    รายการแบบทดสอบทั้งหมด
                  </v-col>
                </v-col>
              </div>
              <div class="option-content">
                <div class="message-container">
                  <div class="message-scroll">
                    <div class="message-detail pa-4">
                      <div
                        class="content mb-4 pa-4"
                        v-for="poll in polls"
                        :key="poll._id"
                      >
                        <v-row align="center" class="ma-0" no-gutters>
                          <v-col>
                            <p class="body-1 mb-0">{{ poll.question }}</p>
                            <!-- If poll closed -->
                            <p class="text-caption font-weight-light mb-0">
                              Vote closing time : {{ poll.time }}
                            </p>
                          </v-col>

                          <!-- If poll active -->
                          <!-- <v-col cols="auto">
                            <v-row no-gutters>
                              <v-col cols="auto" class="mr-2">
                                <a>
                                  <div
                                    class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                                  >
                                    Edit
                                  </div>
                                </a>
                              </v-col>
                              <v-col cols="auto">
                                <a>
                                  <div
                                    class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                                  >
                                    Close now
                                  </div>
                                </a>
                              </v-col>
                            </v-row>
                          </v-col> -->

                          <!-- If poll closed -->
                          <v-col cols="12" class="mt-3">
                            <a @click="viewPollReport(poll)">
                              <div
                                class="button px-3 py-1 subtitle-1 font-weight-light text-center"
                              >
                                <v-icon class="mr-1 white--text pr-3"
                                  >assignment</v-icon
                                >View Report
                              </div>
                            </a>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-slide-y-transition>
        </v-col>

        <v-col
          :cols="12"
          :lg="1"
          :md="1"
          :sm="12"
          class="pa-0 text-center pt-3 pr-1"
        >
          <div class="right-nav px-1 active" @click="liveChatClick()">
            <v-col class="d-flex py-0 pt-3 justify-center">
              <v-img
                src="@/assets/icon/live_chat.png"
                lazy-src="@/assets/icon/live_chat.png"
                max-width="30"
              ></v-img>
            </v-col>
            <v-col class="subtitle-2 pt-0 font-weight-black">Live Chat</v-col>
          </div>
          <div class="right-nav px-1" @click="liveQClick()">
            <v-col class="d-flex py-0 pt-2 justify-center">
              <v-img
                src="@/assets/icon/live_q.png"
                lazy-src="@/assets/icon/live_q.png"
                max-width="20"
              ></v-img>
            </v-col>
            <v-col class="subtitle-2 pt-0 font-weight-black">Live Q</v-col>
          </div>
          <div class="right-nav px-1" @click="nameCheckClick()">
            <v-col class="d-flex py-0 pt-2 justify-center">
              <v-img
                src="@/assets/icon/name_check.png"
                lazy-src="@/assets/icon/name_check.png"
                max-width="30"
              ></v-img>
            </v-col>
            <v-col class="subtitle-2 pt-0 font-weight-black">Name Check</v-col>
          </div>
          <div class="right-nav px-1" @click="participantClick()">
            <v-col class="d-flex py-0 pt-2 justify-center">
              <v-img
                src="@/assets/icon/participant.png"
                lazy-src="@/assets/icon/participant.png"
                max-width="30"
              ></v-img>
            </v-col>
            <v-col class="subtitle-2 pt-0 font-weight-black">Participant</v-col>
          </div>
          <div class="right-nav px-1" @click="pollClick()">
            <v-col class="d-flex py-0 pt-2 justify-center">
              <v-icon style="font-size: 1.75rem">mdi-ballot</v-icon>
            </v-col>
            <v-col class="subtitle-2 pt-0 font-weight-black">Poll</v-col>
          </div>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogDelay" max-width="450">
        <v-card>
          <v-card-title class="headline">เวลาในการตอบคำถาม</v-card-title>

          <v-card-text class="pb-0">
            <v-row>
              <v-col>
                <p class="subtitle-1">
                  เมื่อกดยืนยันแล้ว
                  ผู้ชมถ่ายทอดสดจะสามารถตอบคำถามได้ในเวลาที่กำหนดเท่านั้น
                </p>
                <p class="subtitle-1">
                  <strong class="font-weight-blod">หมายเหตุ</strong
                  >&nbsp;สามารถกำหนดเวลาใหม่ได้ที่นี่
                </p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col class="d-flex pa-0" cols="6">
                <v-text-field
                  hide-details
                  class="mx-3"
                  type="number"
                  v-model="mins"
                  min="0"
                  @change="checkMinMins"
                  single-line
                  outlined
                ></v-text-field>
                <v-spacer></v-spacer>
                <p class="subtitle-1 pt-3">นาที</p>
              </v-col>
              <v-col class="d-flex pa-0" cols="6">
                <v-text-field
                  hide-details
                  class="mx-3"
                  type="number"
                  min="0"
                  max="59"
                  v-model="secs"
                  @change="checkMinSecs"
                  single-line
                  outlined
                ></v-text-field>
                <!-- <v-spacer></v-spacer> -->
                <p class="subtitle-1 pt-3">วินาที</p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mt-3"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="title"
              color="grey darken-1"
              large
              outlined
              @click="dialogDelay = false"
              >ยกเลิก</v-btn
            >

            <v-btn
              class="title"
              color="primary darken-1"
              large
              dark
              @click="sendQuizToLive"
              >ยืนยัน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogViewReport"
        persistent
        scrollable
        max-width="600px"
      >
        <v-card class="overflow-hd">
          <v-toolbar flat class="mb-0">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogViewReport = false"
              >Close</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <div class="q-report">
              <v-row>
                <v-col cols="12" class="pa-0 ml-3">
                  <p class="font-weight-bold title mb-0">
                    Question {{ this.questionNumber + 1 }}
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-card flat tile>
                    <v-img
                      :src="
                        this.arrReportQuiz[0].quizImgQuestion == null ||
                        this.arrReportQuiz[0].quizImgQuestion == ''
                          ? imageReady
                          : this.arrReportQuiz[0].quizImgQuestion
                      "
                      :lazy-src="this.arrReportQuiz[0].quizImgQuestion"
                      aspect-ratio="1"
                      height="60"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-icon
                            v-if="imageReady"
                            class="mx-auto"
                            elevation="3"
                            size="60"
                            >mdi-image</v-icon
                          >
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col cols="9">
                  <p class="subtitle-1 font-weight-bold mb-0">
                    {{ this.arrReportQuiz[0].quizQuestion }}
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-card class="mx-auto">
                    <v-card-title>
                      <p class="subtitle-1 mb-0">Answered</p>
                      <v-spacer></v-spacer>
                      <span
                        :class="`headline font-weight-bold cyan--text`"
                        v-text="this.arrReportQuiz[0].countQuiz"
                      ></span>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card class="mx-auto">
                    <v-card-title>
                      <p class="subtitle-1 mb-0">Not Answer</p>
                      <v-spacer></v-spacer>
                      <span
                        :class="`headline font-weight-bold orange--text`"
                        v-text="this.arrReportQuiz[0].notAnswer"
                      ></span>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-for="reportChoice in arrReportQuiz"
                :key="reportChoice._id"
              >
                <v-col
                  cols="12"
                  class="mb-2"
                  v-for="(choice, index) in reportChoice.quizChoice"
                  :key="choice._id"
                >
                  <v-row class="px-3">
                    <p class="title font-weight-bold mb-0 mr-2">
                      {{ index + 1 }}. {{ choice.text }}
                    </p>
                    <span>
                      <v-card flat tile>
                        <v-img
                          :src="
                            choice.image == null ? imageReady1 : choice.image
                          "
                          :lazy-src="choice.image"
                          aspect-ratio="1"
                          height="50"
                          width="50"
                        >
                          <template v-slot:placeholder>
                            <v-row class="ma-0" align="center" justify="center">
                              <v-icon
                                v-if="imageReady1"
                                class="mx-auto"
                                size="50"
                                >mdi-image</v-icon
                              >
                            </v-row>
                          </template>
                        </v-img>
                      </v-card>
                    </span>
                  </v-row>
                  <v-row class="px-3">
                    <v-spacer></v-spacer>
                    <p class="subtitle-1 font-weight-bold mb-0">
                      {{
                        reportChoice.percentAnswer[index] > 0
                          ? reportChoice.percentAnswer[index]
                          : '0'
                      }}% (
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <a
                            @click="viewChoice(reportChoice.quizId, choice._id)"
                            v-on="on"
                          >
                            <strong
                              id="showFilePanel"
                              class="subtitle-1 font-weight-bold"
                              >{{
                                reportChoice.countAnswer[index].countAnswer
                              }}
                              Answered</strong
                            >
                          </a>
                        </template>
                        <span class="subtitle-1">ดูสถิติ</span> </v-tooltip
                      >)
                    </p>
                    <v-progress-linear
                      :color="
                        reportChoice.quizChoiceCorrect[0] ==
                        reportChoice.quizChoice[index]._id
                          ? 'success'
                          : 'error'
                      "
                      height="20"
                      :value="
                        reportChoice.percentAnswer[index] > 0
                          ? reportChoice.percentAnswer[index]
                          : '0'
                      "
                    ></v-progress-linear>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card class="notification-container dismiss">
            <v-toolbar flat class="mb-0">
              <a @click="goBack">
                <v-list-item>
                  <v-img
                    src="@/assets/icon/bacck.png"
                    lazy-src="@/assets/icon/bacck.png"
                    max-width="20"
                  ></v-img>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-btn text color="primary">Back</v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </a>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialogReport"
                >Close</v-btn
              >
            </v-toolbar>
            <v-card-text>
              <div class="q-report">
                <v-row>
                  <v-col
                    cols="12"
                    class="mb-0"
                    v-for="(reportAnswer, index) in arrReportChoice"
                    :key="reportAnswer._id"
                  >
                    <v-row class="px-3">
                      <v-list-item three-line>
                        <v-list-item-icon>
                          <p class="headline my-3 ml-3 mr-2z">
                            {{
                              paramsChoice.limit * (pageNumberChoice - 1) +
                              (index + 1)
                            }}
                          </p>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0 mr-2">{{
                            reportAnswer.created_by
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            reportAnswer.email
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-chip
                          class="ma-2"
                          color="#FF8F03"
                          label
                          text-color="white"
                          >{{ reportAnswer.timeUse + ' ' }} sec</v-chip
                        >
                      </v-list-item>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <div class="align-position">
              <v-divider></v-divider>
              <v-card-actions>
                <v-row justify="center">
                  <v-pagination
                    v-model="paramsChoice.page"
                    :length="pageCountChoice"
                    @input="changePageChoice"
                  ></v-pagination>
                </v-row>
              </v-card-actions>
            </div>
          </v-card>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogViewLeaderBoard"
        persistent
        max-width="600"
        class="overflowY"
      >
        <v-card>
          <v-toolbar flat class="mb-0">
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogViewLeaderBoard = false"
              >Close</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <div class="q-report">
              <v-row
                v-for="reportLeader in arrReportLeaderBoard"
                :key="reportLeader._id"
              >
                <v-col cols="4">
                  <v-card color="#308ab7" dark tile class="mx-auto text-right">
                    <v-card-title>
                      <p class="title font-weight-light mb-0">Candidates</p>
                    </v-card-title>
                    <p class="subtitle-1 font-weight-light pb-3 mr-3">
                      {{ reportLeader.allStudentLearner }} students
                    </p>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card color="#308ab7" dark tile class="mx-auto text-right">
                    <v-card-title>
                      <p class="title font-weight-light mb-0">Full Marks</p>
                    </v-card-title>
                    <p class="subtitle-1 font-weight-light pb-3 mr-3">
                      {{ reportLeader.maxScore }} Point
                    </p>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card color="#308ab7" dark tile class="mx-auto text-right">
                    <v-card-title>
                      <p class="title font-weight-light mb-0">Questions</p>
                    </v-card-title>
                    <p class="subtitle-1 font-weight-light pb-3 mr-3">
                      {{ reportLeader.quizAll }} Question
                    </p>
                  </v-card>
                </v-col>
              </v-row>
              <v-row
                v-for="(leaderBoard, index) in arrlistScore"
                :key="leaderBoard._id"
              >
                <v-col cols="12" class="mb-0 py-1">
                  <!-- <v-row class="px-3"> -->
                  <v-list-item three-line>
                    <v-list-item-icon>
                      <v-img
                        v-if="
                          paramsBoard.limit * (pageNumber - 1) + (index + 1) ==
                          1
                        "
                        src="@/assets/icon/gold_coin.png"
                        lazy-src="@/assets/icon/gold_coin.png"
                        max-width="34"
                      ></v-img>
                      <p v-else class="headline my-3 ml-3 mr-2z">
                        {{ paramsBoard.limit * (pageNumber - 1) + (index + 1) }}
                      </p>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="title mb-0 mr-2">{{
                        leaderBoard.displayName
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        leaderBoard.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-chip
                      class="pa-2 text-center"
                      color="#FF8F03"
                      large
                      label
                      text-color="white"
                    >
                      <label>
                        {{ leaderBoard.score }} Point
                        <br />
                        <p class="caption mb-0 text-center">
                          ({{
                            leaderBoard.timeUseMin.toFixed(0) +
                            ' : ' +
                            leaderBoard.timeUseSec.toFixed(2) +
                            ' '
                          }}min)
                        </p>
                      </label>
                    </v-chip>
                  </v-list-item>
                  <!-- </v-row> -->
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <!-- <div class="align-position"> -->
          <v-divider></v-divider>
          <v-card-actions>
            <v-row justify="center">
              <v-pagination
                v-model="paramsBoard.page"
                :length="pageCount"
                @input="changePage"
              ></v-pagination>
            </v-row>
          </v-card-actions>
          <!-- </div> -->
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogAddQuestion"
        scrollable
        max-width="900"
        persistent
      >
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <v-card tile>
            <v-toolbar flat dark color="primary">
              <v-toolbar-title>{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.editAddQuestion'
                )
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn icon dark @click="closeDialog" v-on="on">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span class="subtitle-1">{{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.close'
                  )
                }}</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text>
              <v-card class="my-5 pa-5" elevation="0" color="grey lighten-5">
                <p class="body-1 font-weight-medium mb-0">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-row>
                  <v-col>
                    <v-textarea
                      v-model="questionText"
                      name="input-7-4"
                      solo
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" lg="4">
                    <div class="upload-btn-wrapper">
                      <button class="btn-choose body-1 font-weight-medium">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.liveStep.addLiveDialog.chooseFile'
                          )
                        }}
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        name="myfile"
                        @change="preview"
                      />
                    </div>
                  </v-col>
                </v-row>
                <div
                  class="img-list-preview"
                  v-if="this.imgBool == true || imgPreview"
                >
                  <v-row>
                    <v-col cols="4" :sm="4" :md="4" :lg="4">
                      <div class="img-panel">
                        <v-img
                          :src="imgPreview == null ? imageReady : imgPreview"
                          :lazy-src="imgPreview"
                          aspect-ratio="1"
                          contain
                          height="145px"
                        ></v-img>
                      </div>
                    </v-col>
                    <v-col cols="8" :sm="8" :md="8" :lg="8">
                      <div class="progressContainer">
                        <p class="mb-0">{{ imageName }}</p>
                        <div class="d-flex">
                          <v-progress-linear
                            class="progress"
                            reactive
                            :value="progressPercent"
                            height="10"
                          ></v-progress-linear>
                          <p class="mb-0">{{ progressPercent }}%</p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <v-row>
                <v-col lg="6" cols="12">
                  <p class="body-1 font-weight-medium mb-3">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.score'
                      )
                    }}
                  </p>
                  <v-text-field
                    v-model="question_score"
                    :rules="scoreRules"
                    min="0"
                    type="number"
                    @change="checkMinScore"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col lg="6" cols="12">
                  <p class="body-1 font-weight-medium mb-3">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.timer'
                      )
                    }}
                  </p>
                  <div class="d-flex">
                    <v-text-field
                      class="mr-5"
                      v-model="mins"
                      :rules="minuteRules"
                      type="number"
                      min="0"
                      max="60"
                      @change="checkMinMins"
                      outlined
                      required
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.minute'
                        )
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="secs"
                      :rules="secondRules"
                      type="number"
                      min="0"
                      max="60"
                      @change="checkMinSecs"
                      outlined
                      required
                      :label="
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.liveStep.addLiveDialog.second'
                        )
                      "
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="mr-5"></v-divider>
              <p class="title">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.liveStep.addLiveDialog.answerType'
                  )
                }}
              </p>
              <v-radio-group v-model="radioType" row>
                <v-radio
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.answerText'
                    )
                  "
                  value="text"
                  class="mr-md-12"
                  @change="typeChoice('text')"
                ></v-radio>
                <v-radio
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.answerImage'
                    )
                  "
                  value="image"
                  @change="typeChoice('image')"
                ></v-radio>
              </v-radio-group>
              <v-divider class="my-5"></v-divider>
              <div class="answer-text" v-if="type == 'image'">
                <v-card
                  class="px-5 pt-5 pb-0"
                  elevation="0"
                  color="grey lighten-5"
                >
                  <p class="body-1 font-weight-medium mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.uploadImageAswer'
                      )
                    }}
                  </p>
                  <v-row>
                    <v-col cols="12" lg="4">
                      <div class="upload-btn-wrapper">
                        <button class="btn-choose body-1 font-weight-medium">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.liveStep.addLiveDialog.chooseFile'
                            )
                          }}
                        </button>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          @change="previewImgChoice"
                        />
                      </div>
                    </v-col>
                    <!-- <v-col cols="12" lg="8">
                    <div class="progressContainer">
                      <p class="mb-0">Upload Status</p>
                      <p>70% Complete</p>
                    </div>
                  </v-col>-->
                  </v-row>
                </v-card>
                <v-card elevation="0" class="mt-5">
                  <p class="mb-0 grey--text">
                    <span class="red--text">*</span
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.remark'
                      )
                    }}
                  </p>
                  <div
                    v-for="(src, index) in answer"
                    :key="index + '_quiz_dialog'"
                  >
                    <v-radio-group v-model="answer_correct">
                      <v-row>
                        <v-col cols="1" class="position-radio">
                          <div class="py-5 mr-0">
                            <v-radio :value="index"></v-radio>
                          </div>
                        </v-col>
                        <v-col cols="11">
                          <v-row class="d-flex">
                            <v-col lg="3">
                              <div class="img-panel">
                                <v-img
                                  :src="answer[index].image"
                                  :lazy-src="answer[index].image"
                                  aspect-ratio="1"
                                  contain
                                  height="145px"
                                ></v-img>
                              </div>
                            </v-col>
                            <v-col lg="9">
                              <div class="progressContainer">
                                <div class="d-flex">
                                  <p class="mb-0">
                                    {{ answer[index].fileName }}
                                  </p>
                                  <div class="ml-auto text-rigth">
                                    <v-btn
                                      icon
                                      small
                                      @click="removeRow(index)"
                                      :disabled="answer.length <= 1"
                                    >
                                      <v-icon>mdi-close-circle-outline</v-icon>
                                    </v-btn>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <v-progress-linear
                                    class="progress"
                                    :value="answer[index].progressPercent"
                                    height="10"
                                    reactive
                                  ></v-progress-linear>
                                  <p class="mb-0">
                                    {{
                                      answer[index].progressPercent
                                        ? answer[index].progressPercent
                                        : 0
                                    }}%
                                  </p>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </div>
                </v-card>
              </div>
              <div class="answer-text" v-if="type != 'image'">
                <v-card class="pa-5" elevation="0" color="grey lighten-5">
                  <p class="body-1 font-weight-medium mb-0">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.answer'
                      )
                    }}
                  </p>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="answerText"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        class="mx-2"
                        color="primary"
                        :disabled="this.answerText == ''"
                        @click="addRowAnswer"
                        >{{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.liveStep.addLiveDialog.addAnswer'
                          )
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
                <v-card elevation="0" class="mt-5">
                  <p class="mb-0" style="color: #bdbdbd">
                    <span class="red--text mr-2">*</span
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.liveStep.addLiveDialog.remark'
                      )
                    }}
                  </p>
                  <div
                    v-for="(row, index) in answer"
                    :key="index + '_quiz_dialog'"
                  >
                    <v-radio-group v-model="answer_correct" :mandatory="false">
                      <v-row>
                        <v-col cols="1" class="py-0">
                          <div class="py-2">
                            <v-radio :value="index"></v-radio>
                          </div>
                        </v-col>
                        <v-col cols="10" class="py-0">
                          <v-text-field
                            v-model="answer[index].text"
                            :value="answer[index].text"
                            outlined
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1" class="py-0">
                          <div class="py-1 text-center">
                            <v-tooltip left>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  v-on="on"
                                  color="error"
                                  @click="removeRow(index)"
                                  :disabled="answer.length <= 1"
                                >
                                  <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                              </template>
                              <span class="subtitle-1">{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.liveStep.addLiveDialog.deleteAnswer'
                                )
                              }}</span>
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </div>
                </v-card>
              </div>
            </v-card-text>
            <v-divider class="mt-5"></v-divider>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  class="title mx-2"
                  color="blue-grey"
                  outlined
                  @click="closeDialog"
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                    )
                  }}</v-btn
                >
                <v-btn
                  class="title mx-2"
                  color="primary"
                  :disabled="!validationForm()"
                  @click="validate"
                >
                  <v-icon left>mdi-check</v-icon
                  >{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.liveStep.addLiveDialog.save'
                    )
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogSwipe" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.confirmAnswerType'
            )
          }}</v-card-title>
          <v-card-text class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.msg1'
              )
            }}
            <br />{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.msg2'
              )
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2 title"
              large
              dark
              rounded
              outlined
              @click="cancelSwipe"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.cancel'
                )
              }}</v-btn
            >
            <v-btn
              color="error darken-1"
              class="px-10 ma-2 title"
              large
              dark
              rounded
              @click="resetQuestion(tempType)"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.liveStep.addLiveDialog.confirm'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogUpdateSuccess" max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccess'
            )
          }}</v-card-title>

          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.liveStep.addLiveDialog.saveSuccessInfo'
            )
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="closeDialog">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.liveStep.addLiveDialog.done'
              )
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Poll report -->
      <v-dialog
        v-model="dialogPollReport"
        persistent
        scrollable
        max-width="600px"
      >
        <v-card class="overflow-hd vote-poll">
          <v-btn icon @click="dialogPollReport = false" class="close-poll-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-text class="px-7 py-6">
            <v-row class="mb-4" no-gutters>
              <v-col cols="12">
                <p class="font-weight-bold title mb-0">
                  {{ pollReport.question }}
                </p>
                <p class="text-caption font-weight-light mb-0">
                  Vote closing time : {{ pollReport.time }}
                </p>
              </v-col>
            </v-row>

            <v-row class="mb-6" no-gutters>
              <v-col cols="6">
                <v-card class="mx-auto">
                  <v-card-title>
                    <p class="subtitle-1 mb-0">Voted</p>
                    <v-spacer></v-spacer>
                    <span
                      :class="`headline font-weight-bold cyan--text`"
                      v-text="pollReport.countVote"
                    ></span>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>

            <v-row
              align="center"
              v-for="choice in pollReport.choices"
              :key="choice._id"
              no-gutters
              class="choice mb-3"
            >
              <v-col class="pr-4">
                <v-row no-gutters align="center" class="pl-8 pr-2">
                  <v-icon class="mr-4 icon-sign"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                  <v-col class="px-2"
                    ><div class="body-2" style="line-height: 24px">
                      {{ choice.text }}
                    </div></v-col
                  >
                  <v-col cols="auto" v-if="choice.count > 0">
                    (
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <a
                          class="subtitle-1 font-weight-bold"
                          style="line-height: 24px"
                          @click="viewPollChoice(choice.voteHistory)"
                          v-on="on"
                        >
                          {{ choice.count }}&nbsp;voted
                        </a>
                      </template>
                      <span>ดู</span> </v-tooltip
                    >)
                  </v-col>
                  <v-progress-linear
                    :value="choice.percent"
                  ></v-progress-linear>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon class="remove-choice">
                      <v-icon fab small>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove option</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card class="notification-container-poll dismiss">
            <v-toolbar flat class="mb-0">
              <a @click="goBackPoll">
                <v-list-item>
                  <v-img
                    src="@/assets/icon/bacck.png"
                    lazy-src="@/assets/icon/bacck.png"
                    max-width="20"
                  ></v-img>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-btn text color="primary">Back</v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </a>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialogReportPoll"
                >Close</v-btn
              >
            </v-toolbar>
            <v-card-text>
              <div class="q-report">
                <v-row>
                  <v-col
                    cols="12"
                    class="mb-0"
                    v-for="(reportAnswer, index) in arrReportChoicePoll"
                    :key="reportAnswer._id"
                  >
                    <v-row class="px-3">
                      <v-list-item three-line>
                        <v-list-item-icon>
                          <p class="headline my-3 ml-3 mr-2z">
                            {{
                              paramsChoice.limit * (pageNumberChoice - 1) +
                              (index + 1)
                            }}
                          </p>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="title mb-0 mr-2">{{
                            reportAnswer.created_by
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            reportAnswer.email
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <!-- <v-chip
                          class="ma-2"
                          color="#FF8F03"
                          label
                          text-color="white"
                          >{{ reportAnswer.timeUse + ' ' }} sec</v-chip
                        > -->
                      </v-list-item>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <div class="align-position">
              <v-divider></v-divider>
              <v-card-actions>
                <v-row justify="center">
                  <v-pagination
                    v-model="paramsChoice.page"
                    :length="pageCountChoice"
                    @input="changePageChoice"
                  ></v-pagination>
                </v-row>
              </v-card-actions>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
import { insertChoice, updateChoice } from '@/service/course/exam.js';

import {
  getListQuiz,
  insertQuiz,
  updateQuiz,
  deleteQuiz,
} from '@/service/course/quiz.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import axios from 'axios';
import chat from '@/views/course/live/chat.vue';
import participant from '@/views/course/live/tab/participant.vue';
import {
  getLiveStreamStudio,
  sendQuiz,
  reportQuiz,
  reportChoice,
  reportLeaderBoard,
} from '@/service/course/live';
import {
  getListPoll,
  insertPoll,
  votePoll,
  deletePoll,
  updatePoll,
  // insertChoice,
  deleteChoice,
} from '@/service/course/poll.js';
import checkName from '@/views/course/live/checkName.vue';
import player from '@/views/course/live/player.vue';
import info from '@/views/course/live/tab/info.vue';
import pdf from '@/views/course/live/tab/pdf.vue';
import dashboard from '@/views/course/live/tab/dashboard.vue';
import URLLink from '@/views/course/live/tab/URLLink.vue';
import imageLive from '@/views/course/live/tab/imageLive.vue';
import $ from 'jquery';

export default {
  props: {
    openDialog: {
      type: Boolean,
    },
    liveId: {
      type: String,
    },
    changeStep: {
      type: Function,
    },
  },
  components: {
    // videoPlayer
    player,
    chat,
    checkName,
    info,
    participant,
    dashboard,
    URLLink,
    imageLive,
    pdf,
  },
  data() {
    return {
      arrQuestion: [],
      polls: [],
      pollReport: {},
      dialogDelay: false,
      secondItem: [
        '10 วินาที',
        '20 วินาที',
        '30 วินาที',
        '40 วินาที',
        '50 วินาที',
        '60 วินาที',
      ],
      timeDelay: 0,
      idLiveStream: this.liveId,
      idQuiz: '',
      editId: '',
      milliSecs: 0,
      mins: 0,
      secs: 0,
      tempMins: 0,
      tempSecs: 0,
      indexQuestion: null,
      arrHisSendQuiz: [],
      dialogViewReport: false,
      dialogPollReport: false,
      dialogViewLeaderBoard: false,
      dialogSwipe: false,
      dialogDelete: false,
      dialogDeleteSuccess: false,
      dialogUpdateSuccess: false,
      dialogAddQuestion: false,
      dialogAddPoll: false,
      dialogDuplicateSuccess: false,
      setbool: false,

      arrReportQuiz: [
        {
          livestreamID: this.liveId,
          countAllSeeQuiz: 0,
          countAnswer: 0,
          countQuiz: 0,
          percentAnswer: [],
          quizId: '',
          quizQuestion: '',
          quizImgQuestion: '',
          quizChoice: [
            {
              text: '',
              image: '',
            },
          ],
          quizChoiceCorrect: 0,
          notAnswer: 0,
        },
      ],
      arrReportChoice: [],
      arrReportChoicePoll: [],
      arrReportLeaderBoard: [
        {
          allStudentLearner: 0,
          maxScore: 0,
          quizAll: 0,
        },
      ],
      questionNumber: null,
      imageReady: false,
      imgBool: false,
      imageReady1: false,
      idChoice: '',

      imgPreview1: '',
      imgPreviewChoice: [{ preview: '' }],
      imageFile: null,
      imageFileChoice: null,
      type: 'text',
      edit: null,
      choiceCheck: '',
      choiceText: '',
      questionText: '',
      answerText: '',
      answerImage: '',
      answer_correct: 0,
      answer: [],
      imgPreview: '',

      pageCount: 1,
      page: 1,
      pageNumber: 1,
      pageNumberChoice: 1,
      paramsBoard: {},
      pageCountChoice: 1,
      pageChoice: 1,
      paramsChoice: {},
      isLiveChatShow: true,
      isLiveQShow: false,
      isNameCheckShow: false,
      isParticipantShow: false,
      isLivePollShow: false,
      tab: null,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      slug: '',
      data: [],

      liveStreamDetail: null,

      startDateTime: '',
      endDateTime: '',

      avgCompleted: 80,

      courses: ['All Courses', 'English', 'Math', 'Physics'],
      selectedCourse: 'All Courses',

      attendenceSeries: [
        {
          name: 'Num of Students',
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
          ],
        },
      ],
      attendenceChartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: 'zoom',
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left',
        },
        colors: ['#61dafb'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.5,
            stops: [0, 90, 100],
          },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val;
            },
          },
          title: {
            text: 'Num of Students',
          },
        },
        xaxis: {
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:00:00.000Z',
            '2018-09-19T02:00:00.000Z',
            '2018-09-19T03:00:00.000Z',
            '2018-09-19T04:00:00.000Z',
            '2018-09-19T05:00:00.000Z',
            '2018-09-19T06:00:00.000Z',
            '2018-09-19T07:00:00.000Z',
            '2018-09-19T08:00:00.000Z',
            '2018-09-19T09:00:00.000Z',
            '2018-09-19T10:00:00.000Z',
            '2018-09-19T11:00:00.000Z',
            '2018-09-19T12:00:00.000Z',
            '2018-09-19T13:00:00.000Z',
            '2018-09-19T14:00:00.000Z',
            '2018-09-19T15:00:00.000Z',
            '2018-09-19T16:00:00.000Z',
            '2018-09-19T17:00:00.000Z',
            '2018-09-19T18:00:00.000Z',
            '2018-09-19T19:00:00.000Z',
            '2018-09-19T20:00:00.000Z',
            '2018-09-19T21:00:00.000Z',
            '2018-09-19T22:00:00.000Z',
            '2018-09-19T23:00:00.000Z',
          ],
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm',
          },
        },
      },

      examSeries: [
        {
          name: 'Num of Students',
          data: [
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
            100,
            40,
            60,
            80,
            10,
            50,
            20,
          ],
        },
      ],
      examChartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 350,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: 'zoom',
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left',
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100],
          },
        },
        colors: ['#ffd31d'],
        yaxis: {
          labels: {
            formatter: function (val) {
              return val;
            },
          },
          title: {
            text: 'Num of Students',
          },
        },
        xaxis: {
          type: 'datetime',
          categories: [
            '2018-09-19T00:00:00.000Z',
            '2018-09-19T01:00:00.000Z',
            '2018-09-19T02:00:00.000Z',
            '2018-09-19T03:00:00.000Z',
            '2018-09-19T04:00:00.000Z',
            '2018-09-19T05:00:00.000Z',
            '2018-09-19T06:00:00.000Z',
            '2018-09-19T07:00:00.000Z',
            '2018-09-19T08:00:00.000Z',
            '2018-09-19T09:00:00.000Z',
            '2018-09-19T10:00:00.000Z',
            '2018-09-19T11:00:00.000Z',
            '2018-09-19T12:00:00.000Z',
            '2018-09-19T13:00:00.000Z',
            '2018-09-19T14:00:00.000Z',
            '2018-09-19T15:00:00.000Z',
            '2018-09-19T16:00:00.000Z',
            '2018-09-19T17:00:00.000Z',
            '2018-09-19T18:00:00.000Z',
            '2018-09-19T19:00:00.000Z',
            '2018-09-19T20:00:00.000Z',
            '2018-09-19T21:00:00.000Z',
            '2018-09-19T22:00:00.000Z',
            '2018-09-19T23:00:00.000Z',
          ],
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm',
          },
        },
      },
    };
  },
  // watch: {
  //   openDialog(val){
  //     if(!val){
  //       this.clearPlayer()
  //     }
  //   }
  // },
  // beforeDestroy(){
  //   try{
  //   window.jwplayer("live-video").remove();
  //   }catch(err){
  //     console.log(err)
  //   }
  // },
  async mounted() {
    this.initialize();
  },
  computed: {
    scoreRules: [
      (v) =>
        !!v > 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.scoreRules'
        ),
    ],
    minuteRules: [
      (v) =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.minuteRules'
        ),
    ],
    secondRules: [
      (v) =>
        !!v >= 0 ||
        this.$vuetify.lang.t(
          '$vuetify.courseManagement.liveStep.addLiveDialog.secondRules'
        ),
    ],
  },
  methods: {
    async initialize() {
      this.getQuestionList();
      this.getPolls();
      // setTimeout(function() {
      //   $('#containerChat').scrollTop($('#containerChat')[0].scrollHeight);
      // }, 100);

      let streamKeysResult = await getLiveStreamStudio({
        idlivestream: this.liveId,
      });
      this.liveStreamDetail = streamKeysResult;
      // await window.jwplayer("video").setup({
      //     sources: [{file:this.liveStreamDetail.streamDetail.watchURL}],
      //     width: "100%",
      //   })
      await window.jwplayer('live-video').setup({
        sources: [{ file: this.liveStreamDetail.streamDetail.watchURL }],
        width: '100%',
      });
    },
    validationForm() {
      let bool = true;

      this.answer.forEach((item) => {
        if (item.length < 1 || (item.text == '' && item.image == '')) {
          bool = false;
        }
      });
      if (this.mins >= 0 || this.secs >= 0) {
        this.valid = true;
      }
      return this.valid && bool;
    },
    editQuestion(qId) {
      console.log(qId);
      this.dialogAddQuestion = true;
      // this.edit = index;
      this.editId = qId;
      console.log(this.editId);
      let tempMin = null;
      let tempSec = null;
      // if (this.mins >= 0 || this.secs >= 0) {
      //   this.$refs.form.resetValidation();
      // }
      for (var i = 0; i < this.arrQuestion.length; i++) {
        if (this.editId == this.arrQuestion[i].id) {
          tempMin = this.arrQuestion[i].time / 1000 / 60;
          tempSec = (this.arrQuestion[i].time / 1000) % 60;
          this.mins = parseInt(tempMin);
          this.secs = tempSec;
          this.questionText = this.arrQuestion[i].question;
          this.imgPreview = this.arrQuestion[i].imageQuestion;
          if (this.imgPreview) {
            this.imgBool = true;
            this.imageReady = true;
          }

          this.question_score = this.arrQuestion[i].score;
          this.answer = this.arrQuestion[i].choices;
          this.imageReady1 = true;
          this.answer_correct = this.arrQuestion[i].correctAnswer[0];
          this.choiceCheck = this.arrQuestion[i].correctAnswer[0];

          this.answer.forEach((value, index) => {
            if (this.answer_correct === value._id) {
              this.answer_correct = index;
              console.log(this.answer_correct);
            }
          });

          if (
            this.arrQuestion[i].choices[0].text == '' ||
            this.arrQuestion[i].choices[0].text == null
          ) {
            this.type = 'image';
          }
          if (
            this.arrQuestion[i].choices[0].image == '' ||
            this.arrQuestion[i].choices[0].image == null
          ) {
            this.type = 'text';
          }
        }
      }

      console.log('get edit type : ', this.radioType);
      this.radioType = this.type;
      console.log(this.answer);
      console.log(this.imgPreview);
      console.log(this.answer_correct);
    },

    async validate() {
      if (this.$refs.form.validate()) {
        console.log(this.answer);
        let arrChoiceId = [];
        let choiceCorrect = [];

        if (this.mins == 0 && this.secs == 0) {
          console.log('minute = 0 && second = 0');
          return;
        }

        if (this.imageFile != null) {
          await this.uploadImg(this.imageFile);
          console.log('UPLOADED IMAGE:', this.imgPreview);
        }

        if (this.type == 'image') {
          console.log('ANSWER', this.answer);
          this.answer.forEach(async (choice, index) => {
            if (choice._id) {
              console.log(choice._id);
            } else {
              console.log('image choice local : ', choice.file);
              await this.uploadImgChoice(index, choice.file);
              console.log('UPLOADED IMAGE:', choice.image);
            }
          });
        }

        if (this.mins >= 0 || this.secs >= 0) {
          this.$refs.form.resetValidation();
        }

        for (var i = 0; i < this.answer.length; i++) {
          if (this.answer[i]._id) {
            let result = await updateChoice({
              id: this.answer[i]._id,
              text: this.answer[i].text,
              image: this.answer[i].image,
            });
            await arrChoiceId.push(result._id);
          } else {
            let result = await insertChoice({
              text: this.answer[i].text,
              image: this.answer[i].image,
            });
            await arrChoiceId.push(result._id);
          }
        }

        if (arrChoiceId) {
          arrChoiceId.forEach((value, index) => {
            if (this.answer_correct === index) {
              choiceCorrect.push(value);
              console.log('คำตอบถูก : ', choiceCorrect);
            }
          });
        }
        let milliSec = this.secs * 1000;
        let milliMin = this.mins * 60000;
        let timeLimited = milliMin + milliSec;
        console.log(timeLimited);

        let question = {
          idlivestream: this.liveId,
          question: this.questionText,
          imageQuestion: this.imgPreview,
          choices: arrChoiceId,
          correct: choiceCorrect,
          score: this.question_score,
          time: timeLimited,
        };
        console.log(question);
        if (this.editId) {
          console.log(this.imgPreview);
          let resultQuestion = await updateQuiz({
            idquiz: this.editId,
            ...question,
          });
          console.log(resultQuestion);
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = '';
            this.type = 'text';
            this.questionText = '';
            this.imgPreview = '';
            this.imgPreviewChoice = [{ preview: '' }];
            this.imageFileChoice = null;
            this.imageReady = false;
            this.imageReady1 = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [];
            this.setbool = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        } else {
          let resultQuestion = await insertQuiz(question);
          console.log(resultQuestion);
          if (resultQuestion) {
            this.dialogUpdateSuccess = true;
            this.edit = null;
            this.editId = '';
            this.type = 'text';
            this.questionText = '';
            this.imgPreview = '';
            this.imgPreviewChoice = [{ preview: '' }];
            this.imageFileChoice = null;
            this.imageReady = false;
            this.imageReady1 = false;
            this.question_score = 0;
            this.mins = 0;
            this.secs = 0;
            this.answer = [];
            this.setbool = false;
            this.newQuestion = false;
            this.$refs.form.resetValidation();
            this.getQuestionList();
          }
        }
      } else {
        console.log('not pass');
      }
    },

    async changePage(page) {
      this.page = page;
      await this.getReportLeaderBoard();
    },
    async changePageChoice(page) {
      this.pageChoice = page;
      await this.getReportChoice();
    },
    typeChoice(type) {
      this.tempType = type;
      console.log(type);
      this.dialogSwipe = true;
    },
    closeDialog() {
      this.dialogAddQuestion = false;
      this.dialogUpdateSuccess = false;
      this.dialogDuplicateSuccess = false;
      this.dialogDeleteSuccess = false;
      this.newQuestion = false;
      this.edit = null;
      console.log(this.newQuestion);

      this.setbool = false;
      this.questionText = '';
      this.imgPreview = '';
      this.imgPreview1 = '';
      this.imgPreviewChoice = [{ preview: '' }];
      this.imageFileChoice = null;
      this.imageReady = false;
      this.question_score = 1;
      this.mins = 0;
      this.secs = 30;
      this.answer = [];
      this.editId = '';
      this.type = 'text';

      this.imageFile = null;
      this.imgPreview = '';
      this.imageName = '';
      this.progressPercent = 0;
      this.imgBool = false;

      this.percent = [];
      this.imgSrc = [];
      this.imgFile = [];
      this.getQuestionList();

      this.$refs.form.resetValidation();
    },

    resetQuestion(type) {
      console.log(type);

      switch (type) {
        case 'text':
          this.type = 'text';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.dialogSwipe = false;
          break;
        case 'image':
          this.type = 'image';
          this.percent = [];
          this.imgSrc = [];
          this.imgFile = [];
          this.question_score = 1;
          this.mins = 0;
          this.secs = 30;
          this.answer = [];
          this.dialogSwipe = false;
          break;
        default:
          break;
      }
    },
    cancelSwipe() {
      console.log('befor ', this.type);
      console.log('befor ', this.radioType);
      switch (this.tempType) {
        case 'text':
          this.radioType = 'image';
          this.dialogSwipe = false;
          console.log('after case text ', this.type);
          console.log('after case text ', this.radioType);
          break;
        case 'image':
          this.radioType = 'text';
          this.dialogSwipe = false;
          console.log('after case image ', this.type);
          console.log('after case image ', this.radioType);
          break;
        default:
          break;
      }
    },
    choiceCheckAnswer(choice) {
      this.choiceCheck = choice;
    },
    async deleteQuiz(questionID, streamID) {
      this.dialogDelete = false;
      this.dialogDeleteSuccess = true;
      await deleteQuiz({
        idlivestream: streamID,
        idquiz: questionID,
      });
      this.arrQuestion = [];
      this.getQuestionList();
    },
    addRowAnswer: function () {
      if (this.type == 'text') {
        // if (this.answer.length == 1) {
        // this.answer[0].push({ text: this.answerText });
        // this.answerText = "";
        // } else {
        this.answer.push({ text: this.answerText });
        this.answerText = '';
        // }
      } else {
        // if (this.answer.length == 1) {
        //   this.answer[0].push({ image: this.answerImage });
        // this.answerImage = "";
        // }else{
        this.answer.push({ image: this.answerImage });
        this.answerImage = '';
        // }
      }
      console.log(this.answer);
    },
    removeRow: function (index) {
      console.log('row' + index, this.answer.length);
      console.log(this.answer);
      console.log(this.answer_correct, index);
      // this.rows.$remove(index);
      if (this.answer.length > 1) {
        if (this.answer_correct === index) {
          this.answer_correct = 0;
        } else if (this.answer_correct > index) {
          this.answer_correct = this.answer_correct - 1;
        }
        this.answer.splice(index, 1);
      }
    },
    async uploadImg(file) {
      // let status = await uploadImage("question", image);
      // return status;
      this.showUploadPercent = true;

      let formData = new FormData();
      formData.append('fileupload', file);
      formData.append('title', file.name);
      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            console.log(response.data.result);

            this.imgPreview = response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },

    async uploadImgChoice(index, file) {
      let formData = new FormData();
      formData.append('fileupload', file);
      // formData.append("title", file.name);

      await axios
        .post(`${domain}/uploadfile/public/image/question`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            let progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.updateProgress(index, progressPercent);
          }.bind(this),
        })
        .then(
          async function (response) {
            console.log(response.data.result);

            this.answer[index].image = await response.data.result;
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);
        });
    },

    async preview(event) {
      let file = event.target.files[0];

      this.imageFile = file;
      this.imgPreview = await URL.createObjectURL(file);
      this.imageName = file.name;
      this.imgBool = true;
    },

    async previewImgChoice(event) {
      let totalFiles = event.target.files.length;
      for (var i = 0; i < totalFiles; i++) {
        let file = event.target.files[i];
        // this.imgFile.push(file);

        // this.imgSrc.push({
        //   name: file.name,
        //   src: await URL.createObjectURL(file),
        //   progressPercent: 0
        // });
        this.answer.push({
          image: await URL.createObjectURL(file),
          progressPercent: 0,
          file: file,
          fileName: file.name,
        });
      }
      console.log(this.answer);
    },
    updateProgress(index, percent) {
      this.answer[index].progressPercent = percent;
    },
    checkMinMins() {
      if (this.mins < 0) {
        this.mins = 0;
      } else if (this.mins >= 60) {
        this.mins = 59;
      }
      this.mins = Math.floor(this.mins);
    },
    checkMinSecs() {
      if (this.secs < 0) {
        this.secs = 0;
      } else if (this.secs >= 60) {
        this.secs = 59;
      }
      this.secs = Math.floor(this.secs);
    },
    viewChoice(idQuiz, idChoice) {
      this.idQuiz = idQuiz;
      this.idChoice = idChoice;
      this.getReportChoice();
    },
    closeDialogReport() {
      this.dialogViewReport = false;
      this.goBack();
    },
    closeDialogReportPoll() {
      this.dialogPollReport = false;
      this.goBackPoll();
    },
    goBackPoll() {
      this.setbool = false;
      if ($('.notification-container-poll').hasClass('selected')) {
        $('.notification-container-poll')
          .removeClass('selected')
          .addClass('dismiss');
      }
    },
    goBack() {
      this.setbool = false;
      if ($('.notification-container').hasClass('selected')) {
        $('.notification-container')
          .removeClass('selected')
          .addClass('dismiss');
      }
    },
    viewReport(id, index) {
      this.idQuiz = id;
      this.questionNumber = index;
      this.getReportQuiz();
    },

    async getReportQuiz() {
      this.params = {
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
      };
      let result = await reportQuiz({
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
      });
      this.arrReportQuiz = [];
      this.arrReportQuiz.push({
        livestreamID: this.liveId,
        countAllSeeQuiz: result.countAllSeeQuiz,
        countAnswer: result.countAnswer,
        countQuiz: result.countQuiz,
        percentAnswer: [],
        quizId: result.quiz._id,
        quizQuestion: result.quiz.question,
        quizImgQuestion: result.quiz.imageQuestion,
        quizChoice: result.quiz.choices,
        quizChoiceCorrect: result.quiz.correct,

        notAnswer: result.countAllSeeQuiz - result.countQuiz,
      });
      this.arrReportQuiz[0].countAnswer.forEach((value) => {
        this.arrReportQuiz[0].percentAnswer.push(
          ((value.countAnswer / this.arrReportQuiz[0].countQuiz) * 100).toFixed(
            1
          )
        );
      });
      if (this.arrReportQuiz) {
        this.dialogViewReport = true;
      }
      if (
        this.arrReportQuiz[0].quizImgQuestion == '' ||
        this.arrReportQuiz[0].quizImgQuestion == null
      ) {
        this.imageReady = true;
      }
    },
    async getReportChoice() {
      this.paramsChoice = {
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
        idanswer: this.idChoice,
        page: this.pageChoice,
        limit: 5,
      };
      let result = await reportChoice(this.paramsChoice);
      this.arrReportChoice = [];
      this.pageCountChoice = result.maxPage;
      result.data.forEach((quiz) => {
        this.arrReportChoice.push({
          livestreamID: this.liveId,
          id: quiz._id,
          timeUse: (quiz.timeUse / 1000).toFixed(2),
          created_by: quiz.created_by.displayName,
          email: quiz.created_by.email,
          studentId: quiz.created_by._id,
        });
      });
      this.pageNumberChoice = this.pageChoice;
      this.setbool = true;
      if ($('.notification-container').hasClass('dismiss')) {
        $('.notification-container')
          .removeClass('dismiss')
          .addClass('selected')
          .show();
      }
    },

    async viewLeaderBoard() {
      this.getReportLeaderBoard();
    },

    async getReportLeaderBoard() {
      this.paramsBoard = {
        idlivestream: this.liveId,
        page: this.page,
        limit: 4,
      };

      let result = await reportLeaderBoard(this.paramsBoard);
      this.arrReportLeaderBoard = [];
      this.arrlistScore = [];
      this.arrReportLeaderBoard.push({
        livestreamID: this.liveId,
        allStudentLearner: result.allStudentLearner,
        maxScore: result.maxScore,
        quizAll: result.quizAll,
      });
      this.pageCount = result.dataScore.maxPage;
      result.dataScore.data.forEach((list) => {
        this.arrlistScore.push({
          id: list._id,
          timeUseMin: list.timeUse / 1000 / 60,
          timeUseSec: (list.timeUse / 1000) % 60,
          score: list.count,
          displayName: list.displayName,
          email: list.email,
        });
      });
      this.pageNumber = this.page;

      this.dialogViewLeaderBoard = true;
    },

    async getQuestionList() {
      this.params = {
        idlivestream: this.liveId,
      };
      let result = await getListQuiz({
        idlivestream: this.liveId,
      });
      this.arrQuestion = [];
      result.data.forEach((quiz) => {
        this.arrQuestion.push({
          id: quiz._id,
          livestreamID: this.liveId,
          question: quiz.question,
          choices: quiz.choices,
          correctAnswer: quiz.correct,
          imageQuestion: quiz.imageQuestion,
          score: quiz.score,
          time: quiz.time,
          historySend: quiz.historySend,
        });
      });
    },

    async getPolls() {
      const res = await getListPoll({
        idlivestream: this.liveId,
        limit: 100,
        page: 1,
      });

      this.polls = res.data;
    },

    editPoll() {
      this.dialogAddPoll = true;
    },

    viewPollReport(poll) {
      const count = poll.choices.filter((c) => c.voted === true).length;

      this.pollReport = { ...poll, ...{ countVote: count } };
      this.dialogPollReport = true;
    },
    async viewPollChoice(voteHistory) {
      console.log('voteHistory :: ', voteHistory);
      let result = voteHistory;
      // this.paramsChoice = {
      //   idlivestream: this.liveId,
      //   idquiz: this.idQuiz,
      //   idanswer: this.idChoice,
      //   page: this.pageChoice,
      //   limit: 5
      // };
      // // let result = await reportChoice(this.paramsChoice);
      this.arrReportChoicePoll = [];
      // this.pageCountChoicePoll = result.maxPage;
      result.forEach((quiz) => {
        this.arrReportChoicePoll.push({
          livestreamID: this.liveId,
          id: quiz.id,
          // timeUse: 200,
          created_by: `${quiz.firstName} ${quiz.lastName}`,
          email: 'email',
          studentId: quiz.id,
        });
      });
      this.pageNumberChoice = this.pageChoice;
      this.setbool = true;
      if ($('.notification-container-poll').hasClass('dismiss')) {
        $('.notification-container-poll')
          .removeClass('dismiss')
          .addClass('selected')
          .show();
      }
    },

    showTimeQuestion(id, time) {
      this.dialogDelay = true;
      this.idQuiz = id;
      this.mins = parseInt(time / 1000 / 60);
      this.secs = (time / 1000) % 60;
      this.timeDelay = time;
      this.tempMins = this.mins;
      this.tempSecs = this.secs;
    },

    sendQuizToLive() {
      this.dialogDelay = false;
      // console.log("index : ", this.secondItem, this.timeDelay);
      // this.secondItem.forEach((timeValue, index) => {
      //   if (this.timeDelay === timeValue) {
      //     this.milliSecs = (index + 1) * 10 * 1000;
      //     console.log("milli second : ", this.milliSecs);
      //   }
      // });
      this.timeDelay = this.mins * 60 * 1000 + this.secs * 1000;
      this.sendQuiz();
    },

    async sendQuiz() {
      let question = {
        idlivestream: this.liveId,
        idquiz: this.idQuiz,
        delay: this.timeDelay,
      };

      await sendQuiz(question);
      this.getQuestionList();
    },

    setCurrentMenu(index) {
      var item = $('.right-nav')[index];
      if ($('.right-nav').hasClass('active')) {
        $('.right-nav').removeClass('active');
      }

      $('div').find(item).addClass('active');

      this.isLiveChatShow = false;
      this.isLiveQShow = false;
      this.isParticipantShow = false;
      this.isNameCheckShow = false;
      this.isLivePollShow = false;
    },

    liveChatClick() {
      this.setCurrentMenu(0);
      this.isLiveChatShow = true;
    },
    liveQClick() {
      this.setCurrentMenu(1);
      this.isLiveQShow = true;
    },
    nameCheckClick() {
      this.setCurrentMenu(2);
      this.isNameCheckShow = true;
    },
    participantClick() {
      this.setCurrentMenu(3);
      this.isParticipantShow = true;
    },
    pollClick() {
      this.setCurrentMenu(4);
      this.isLivePollShow = true;
    },
  },
};
</script>

<style scoped lang="scss">
.btnLeader {
  border-radius: 0px !important;
}
.message-container {
  position: relative;
  height: 77vh;
  background-color: white;
}
.align-position {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.overflowY {
  overflow-y: inherit;
}
.message-scroll {
  height: 80vh;
  overflow: hidden;
}
.v-dialog .v-dialog--active {
  overflow: inherit;
}
.notification-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  display: none;
  height: 100%;
  overflow: hidden;
  background: #ebdbbf;
  z-index: 999;
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.notification-container-poll {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  display: none;
  height: 100%;
  overflow: hidden;
  background: #ebdbbf;
  z-index: 999;
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.selected {
  animation: slide-in 0.3s forwards;
  -webkit-animation: slide-in 0.3s forwards;
}

.dismiss {
  animation: slide-out 0.3s forwards;
  -webkit-animation: slide-out 0.3s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-webkit-keyframes slide-out {
  0% {
    -webkit-transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(100%);
  }
}
.q-detail {
  height: 610px;
  overflow-y: scroll;
}
.q-report {
  height: 620px;
}
.overflow-hd {
  overflow-x: hidden !important;
}
.page-card {
  border-radius: 0px !important;
  transition: transform 0.3s ease-in-out;
}

.datetime {
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.datetime:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.selectCourse {
  height: auto;
  border: 0px;
  padding: 15px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out;
}

.selectCourse:hover {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19);
}

.progress-bar {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.9);
}

.card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.option {
  transition: transform 0.3s ease-in-out;
  color: white;
  .tab-live-detail {
    &.v-tab--active {
      border: 0;
      background: #ff8f03;
    }
  }
}

.option-content {
  transition: transform 0.3s ease-in-out;
  background: white;
  border-bottom: 1px solid #eeeeef;
  border-left: 1px solid #eeeeef;
  border-right: 1px solid #eeeeef;
}
.message-detail {
  height: 85%;
  overflow-y: scroll;
  padding-top: 15px;
}
.content {
  border-radius: 10px;
  transition: transform 0.3s ease-in-out;
  background-color: #efefef;
}

.button {
  // box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  // border-radius: 5px;
  transition: transform 0.3s ease-in-out;
  background-color: #50adde;
  color: white;
  height: 35px;
}
.cardQ {
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 12px;
}

.button:hover {
  transform: scale(0.95, 0.95);
}

.right-nav {
  transition: transform 0.3s ease-in-out;
  color: #9d9d9d;
  margin: 0;
  padding: 10px 0;
  .v-image {
    filter: grayscale(1);
    width: 50px;
  }
  i {
    color: inherit !important;
  }
  &.active {
    color: #ff8f03;
    background: white;
    .v-image {
      filter: none;
    }
  }
  &:hover {
    background: white;
    cursor: pointer;
  }
}
// .v-tabs:not(.v-tabs--vertical) .v-tab {
//   flex-grow: 1;
//   border-right-style: solid;
//   border-right-width: thin;
//   border-right-color: #eeeeef;
// }

.live-preview {
  background: rgba(0, 0, 0, 0.8);
  height: 500px;
  width: 100%;
  transition: transform 0.3s ease-in-out;
}

.live-detail {
  transition: transform 0.3s ease-in-out;
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.9));
  border-style: solid;
  border-width: thin;
  border-color: #eeeeef;
  border-right: unset;
  border-radius: 3px;
}

.live-detail-content {
  transition: transform 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.09);
  border-top-style: solid;
  border-top-width: thin;
  border-top-color: #eeeeef;
  border-right-style: solid;
  border-right-width: thin;
  border-right-color: #eeeeef;
  background-color: #fff !important;
}

.card-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.card-navigation {
  background-image: linear-gradient(rgba(#0779e4, 0.7), rgba(#0779e4, 0.4));
  color: white;
}

.card-corner {
  background-image: linear-gradient(rgba(#4cbbb9, 0.8), rgba(#4cbbb9, 0.5));
  color: white;
}

.card-right {
  background-image: linear-gradient(rgba(#084177, 0.5), rgba(#084177, 0.3));
  color: white;
}

.videoPlayer {
  width: 100%;
}

.graph-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  transform: scale(1.02, 1.02);
}
.full-width {
  width: 96%;
}
.header-option {
  background: #308ab7;
  color: white;
}
.menu-title {
  padding-top: 10px;
  padding-bottom: 20px;
  padding-right: 10px;
  padding-left: 10px;
}
.divQ {
  padding-top: 10px;
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 10px;
}
.v-tabs-slider-wrapper {
  height: 0px !important;
}

.vote-poll {
  .choice {
    .icon-sign {
      position: absolute;
      top: 0;
      left: 0;
    }

    .v-progress-linear {
      position: absolute;
      top: 0;
      left: 32px;
      width: calc(100% - 32px);
      height: 100% !important;
      border-radius: 4px;
      opacity: 0.16;
    }

    .row {
      position: relative;
    }

    .col {
      z-index: 1;
    }

    button {
      width: auto !important;
      height: auto !important;
      background: initial !important;
      border-radius: 50% !important;
    }
  }

  .close-poll-btn {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
</style>
